<template>

<v-dialog v-model="dialog" width="500px">
  <v-card>
    <p class=".title ma-2">Modify Guest Payment Terms</p>
    <v-form ref="updHklrTerms" v-model="updHklrTermsValid">
     <v-row no-gutters>

      <v-col class="ma-2">
       <v-menu
              v-model="huov_hklr_term1_datummenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              readonly 
              offset-y
              min-width="290px"
        >
        <template v-slot:activator="{ on }">
            <v-text-field
              v-model="huov.huov_hklr_term1_datum"
              label="Payment term 1 Date"
              v-on="on"
            ></v-text-field>
        </template>
        <v-date-picker v-model="huov.huov_hklr_term1_datum2" :first-day-of-week="1" @input="huov.huov_hklr_term1_datum = $moment(huov.huov_hklr_term1_datum2).format('DD-MM-YYYY'); huov_hklr_term1_datummenu = false"></v-date-picker>
       </v-menu>  

      </v-col>
      <v-col class="ma-2">
       <v-select v-model="huov.huov_hklr_term1_tijd" required :items="tijd_idKeuzes" item-value="tijd_id" item-text="tijd_oms" label="Payment term 1 Time"></v-select>
      </v-col>
      <v-col class="ma-2">
          <v-text-field v-model="huov.huov_hklr_term1_bedrag" required label="Amount" :prefix=huov.valu_code_verk type="number" :rules="hklr_bedragRules"></v-text-field>
        </v-col>

     </v-row>

     <v-row no-gutters>
      <v-col class="ma-2">
       <v-menu
              v-model="huov_hklr_term2_datummenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              readonly 
              offset-y
              min-width="290px"
        >
        <template v-slot:activator="{ on }">
            <v-text-field
              v-model="huov.huov_hklr_term2_datum"
              label="Payment term 2 Date"
              v-on="on"
            ></v-text-field>
        </template>
        <v-date-picker v-model="huov.huov_hklr_term2_datum2" :first-day-of-week="1" @input="huov.huov_hklr_term2_datum = $moment(huov.huov_hklr_term2_datum2).format('DD-MM-YYYY'); huov_hklr_term2_datummenu = false"></v-date-picker>
       </v-menu>  
      </v-col>
      <v-col class="ma-2">
       <v-select v-model="huov.huov_hklr_term2_tijd" required :items="tijd_idKeuzes" item-value="tijd_id" item-text="tijd_oms" label="Payment term 1 Time"></v-select>
      </v-col>
      <v-col class="ma-2">
          <v-text-field v-model="huov.huov_hklr_term2_bedrag" required label="Amount" :prefix=huov.valu_code_verk type="number" :rules="hklr_bedragRules"></v-text-field>
        </v-col>

     </v-row>

    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="primary mx-2" small @click="updHklrTerms" :disabled="!updHklrTermsValid">Save</v-btn>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      updHklrTermsValid: false,
      huov_encrid: null,
      tijd_idKeuzes: [],
      huov: {},
      huov_hklr_term1_datummenu: false,
      huov_hklr_term2_datummenu: false,
      hklr_bedragRules: [
          v => (v && parseFloat(v) >= 0.0)  || "An amount is required"
      ]    
    }
  },
  methods: {
    open(huov_encrid) {
      var deze = this;
      this.$emit("showSnackbar");
      this.dialog = true;
      this.huov_encrid = huov_encrid;
      this.tijd_id = '';
      this.$axios
        .post("ares/json/ares/huov/hklr/getHklrTerms.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHklrTerms"
          },
          getHklrTerms: {
            huov_encrid: huov_encrid,
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.huov = res.data.getHklrTerms;
            res.data.getHklrTerms.tijd_idKeuzes.forEach(function(tijd) {
            deze.tijd_idKeuzes.push(tijd); 
           });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updHklrTerms() { 
      this.$axios
        .post("ares/json/ares/huov/hklr/updHklrTerms.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "updHklrTerms"
          },
          updHklrTerms: {
            huov_encrid: this.huov_encrid,
            huov_hklr_term1_tijd: this.huov.huov_hklr_term1_tijd,
            huov_hklr_term1_datum: this.huov.huov_hklr_term1_datum,
            huov_hklr_term1_bedrag: parseFloat(this.huov.huov_hklr_term1_bedrag),
            huov_hklr_term2_tijd: this.huov.huov_hklr_term2_tijd,
            huov_hklr_term2_datum: this.huov.huov_hklr_term2_datum,
            huov_hklr_term2_bedrag: parseFloat(this.huov.huov_hklr_term2_bedrag)
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else {    
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.updHklrTerms.text,
              color: res.data.updHklrTerms.color
            }); 
            if (res.data.updHklrTerms.color == "success") {
              setTimeout(() => { this.$router.reload('/huov/onHuov/' + res.data.updHklrTerms.huov_encrid);  }, 1000); 
            }
            this.dialog = false;
          }
        })
    },
  }
}
</script>

